$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('product-adsorption')) {
    customElements.define(
      'product-adsorption',
      class ProductAdsorption extends HTMLElement {
        sticky_start = 0;
        changeStatus = false;
        _this = null;
        clickPoint = false;
        constructor() {
          super();
        }
        connectedCallback() {
          const _this = this;
          this.init();
          $(window).on('scroll', _this.scrollHandler.bind(_this));
        }
        disconnectedCallback() {
          const _this = this;
          $(window).off('scroll', _this.scrollHandler.bind(_this));
        }

        scrollHandler() {
          if (this.clickPoint) return;

          const adsorption = $('#adsorption');
          const Points = $(`[data-jump]`);
          let sticky = adsorption.offset().top;
          const scrollTop = $(window).scrollTop();
          const scrollingDown = scrollTop > (this.lastScrollTop || 0);
          this.lastScrollTop = scrollTop;

          if (scrollTop > sticky && !this.changeStatus) {
            this.changeStatus = true;
            this.sticky_start = sticky;
            adsorption.addClass('adsorption_sticky');
            adsorption.css('top', '0');
          }
          if (this.changeStatus && $(window).scrollTop() < this.sticky_start - 10) {
            this.changeStatus = false;
            adsorption.removeClass('adsorption_sticky');
            adsorption.css('top', '0');
          } else if (this.changeStatus) {
            adsorption.css('top', '0');
          }

          // 精确视口顶部对齐检测
          const scrollY = $(window).scrollTop();
          const headerHeight = $('#lt-header').outerHeight() || 0;
          const activationThreshold = 50; // 允许50像素的误差范围

          let closestSection = null;
          let minOffset = Infinity;

          $('a[href^="#"]').each(function () {
            const targetId = $(this).attr('href').replace('#', '');
            if (!targetId) return;

            const $target = $(`#${targetId}`);
            if (!$target.length) return;

            // 计算目标区块顶部位置（考虑固定头部）
            const targetTop = $target.offset().top - headerHeight;

            // 计算与视口顶部的距离差
            const offset = Math.abs(targetTop - scrollY);

            // 找到最接近视口顶部的区块
            if (offset < minOffset) {
              minOffset = offset;
              closestSection = this;
            }
          });

          // 仅在达到阈值时更新状态
          if (closestSection) {
            $('a[href^="#"]').removeClass('adsorption_active');
            $(closestSection).addClass('adsorption_active');
          }
        }

        init() {
          const _this = this;
          let adsorption = $('#adsorption');
          this.sticky_start = adsorption.offset().top;

          // 修改点击事件处理
          $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            const targetId = $(this).attr('href').replace('#', '');
            const $target = $(`#${targetId}`);

            if ($target.length) {
              const headerHeight = $('#lt-header').outerHeight() || 0;
              const targetTop = $target.offset().top - headerHeight;

              _this.clickPoint = false;
              _this.scrollHandler();
            }
          });
        }
      }
    );
  }
});
